import { getAppConfig } from '@telescope/cassini-utilities';
const { basename } = getAppConfig();

export const getSSORedirectUri = () => {
  var url = new URL(window.location.origin);
  url.pathname = `${basename}/auth`;
  url.search = window.location.search

  return url.toString();
}